export const CHANGE_COMPANY_FIELD = 'CHANGE_COMPANY_FIELD'
export const RESET_COMPANY = 'RESET_COMPANY'
export const SET_COMPANY = 'SET_COMPANY'
